import React, { useState } from "react";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  leadSourceBreakdownOptions,
  leadSourcesName,
} from "./lead-source-breakdown.constant";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { Box, Button, useMediaQuery } from "@mui/material";
import "./lead-source-breakdown.scss";

const LeadSourceBreakdown = (props: any) => {
  const {
    leadsBySourceBreakdown,
    handleAddLeadReports,
    enableExport = false,
    partnerId,
  } = props;
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });

  const handleExport = async () => {
    try {
      const response = await ApexCharts.exec("lead-source-chart", "dataURI");
      handleAddLeadReports(
        { imageData: response.imgURI.split(",")[1] },
        { section: "source-breakdown", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  const loginData = React.useMemo(() => {
    return JSON.parse(localStorage.getItem("loginData") || "{}");
  }, []);
  const isTenant = loginData?.tenantDetails?.tenantType === "Tenant";
  const includeAFP = isTenant || !!partnerId;

  const dynamicLeadSourcesName = [
    ...leadSourcesName,
    ...(includeAFP ? ["AFP"] : []),
  ];

  const leadsBySourceBreakdownCount = dynamicLeadSourcesName.map(
    (source: string) => {
      return (
        leadsBySourceBreakdown?.find((item: any) => item.source === source)
          ?.count || 0
      );
    }
  );

  const chartOptions = {
    ...leadSourceBreakdownOptions,
    xaxis: {
      ...leadSourceBreakdownOptions.xaxis,
      categories: dynamicLeadSourcesName,
    },
  };

  const series = [
    {
      name: "Lead Count",
      data: leadsBySourceBreakdownCount,
    },
  ];

  const isMobile = useMediaQuery("(max-width:1024px)");

  return (
    <Box className="lead-cpl-wrapper lead-source-breakdown-wrapper">
      <Box className="cpl-wrapper">
        <Box>
          <Box
            sx={{
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="active-users-header"
          >
            <p className="header-text">Lead Source Breakdown</p>
            <Box sx={{ display: "flex", gap: 1 }} className="export-wrapper">
              <Select
                options={[
                  { value: "pdf", label: "PDF" },
                  { value: "csv", label: "CSV" },
                ]}
                isSearchable={false}
                onChange={(e: any) => setFileFormat(e)}
                value={fileFormat}
                className="select-dropdown"
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => {
                    return (
                      <components.DropdownIndicator {...props}>
                        <ArrowDropDownIcon
                          style={{ fontSize: 20, color: "black" }}
                        />
                      </components.DropdownIndicator>
                    );
                  },
                }}
              />
              <Button
                variant="outlined"
                onClick={handleExport}
                className="address-edit-button"
                disabled={!enableExport}
              >
                Export
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              padding: "0px 20px",
              overflowX: "auto",
              boxSizing: "border-box",
              overflowY: "hidden",
            }}
          >
            <div
              style={{
                width: `${isMobile ? `${50 * series[0].data.length}px` : "auto"}`,
              }}
            >
              <Chart
                options={chartOptions}
                series={series}
                type="bar"
                height={350}
              />
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LeadSourceBreakdown;
